// Cambistas e clientes são o mesmo nível na API (`nivel = operador`), separados
// pelo `tipo_usuario`. No painel cada um tem o próprio menu: a listagem pede só o
// tipo dela e a tela de criar grava só aquele tipo. O tipo não muda depois de criado.
export const TIPOS_OPERADOR = {
    cambista: {
        tipo: 'cambista',
        titulo: 'Cambistas',
        nome: 'Cambista',
        singular: 'cambista',
        tituloCriar: 'Criar cambista',
        tituloEditar: 'Atualizar Cambista',
        botaoCriar: 'Novo Cambista',
        contagem: 'vendedores encontrados',
        rotaLista: '/',
        rotaCriar: '/usuarios/criar/operador',
    },
    cliente: {
        tipo: 'cliente',
        titulo: 'Clientes',
        nome: 'Cliente',
        singular: 'cliente',
        tituloCriar: 'Criar cliente',
        tituloEditar: 'Atualizar Cliente',
        botaoCriar: 'Novo Cliente',
        contagem: 'clientes encontrados',
        rotaLista: '/clientes',
        rotaCriar: '/clientes/criar',
    },
};

// Qualquer coisa que não seja exatamente "cliente" é cambista: os operadores
// antigos estão sem tipo (null) e o painel antigo chegou a gravar "gerente".
export function tipoOperador(tipo) {
    return TIPOS_OPERADOR[tipo === 'cliente' ? 'cliente' : 'cambista'];
}

export function ehCliente(usuario) {
    return usuario?.tipo_usuario === 'cliente';
}
